<div class="chat-prop-card" [ngClass]="'chat-prop-card--' + tone">
  <span class="chat-prop-card__icon"><chat-icon name="file" [size]="16"></chat-icon></span>
  <div class="chat-prop-card__body">
    <div class="chat-prop-card__title">{{ strings.proposalCardTitle }}<span *ngIf="statusText" class="chat-prop-card__pill">{{ statusText }}</span></div>
    <div *ngIf="value" class="chat-prop-card__value">{{ value }}</div>
    <div class="chat-prop-card__actions" *ngIf="canManage && dealId">
      <a class="chat-prop-card__btn" [routerLink]="['/deals', 'sale', dealId]">{{ strings.openProposal }}</a>
    </div>
  </div>
</div>
